import React, { useState } from 'react';
import axios from 'axios';

// Her istekte cagrilir - modul yuklendigi anda tek seferlik yakalanan bir sabit
// olsaydi, giristen once/sonra token degisiklikleri yansimaz, 401 sonrasi
// App.js'teki global interceptor oturumu kapatirdi.
const getAuthHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('admin_token')}` } });

// Serbest metin sektor + bolge aramasi - CRM'in kendi destekledigi sektorlerle
// SINIRLI DEGIL (kullanici karari): personel Google'da aranacak herhangi bir
// anahtar kelimeyi yazabilir, cunku prospecting havuzu bugunku sektorlerden
// daha genis olabilir.
const DiscoveryView = () => {
  const [sector, setSector] = useState('');
  const [region, setRegion] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [nextPageToken, setNextPageToken] = useState(null);

  const runSearch = async (pageToken) => {
    if (!sector.trim() || !region.trim()) {
      setError('Sektör ve bölge alanları zorunludur.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/admin/callcenter/search', { sector, region, pageToken }, getAuthHeaders());
      setResult(prev => pageToken && prev
        ? { ...res.data, leads: [...prev.leads, ...res.data.leads] }
        : res.data);
      setNextPageToken(res.data.next_page_token);
    } catch (err) {
      setError(err.response?.data?.error || 'Arama başarısız oldu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
        <input
          placeholder="Sektör (örn. güzellik salonu, kuaför...)"
          value={sector}
          onChange={(e) => setSector(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #d1d5db', minWidth: 260 }}
        />
        <input
          placeholder="Bölge (örn. Ankara, Çankaya...)"
          value={region}
          onChange={(e) => setRegion(e.target.value)}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1px solid #d1d5db', minWidth: 200 }}
        />
        <button
          onClick={() => runSearch(null)}
          disabled={loading}
          style={{ padding: '8px 20px', borderRadius: 6, border: 'none', background: '#2563eb', color: '#fff', fontWeight: 600, cursor: 'pointer' }}
        >
          {loading ? 'Aranıyor...' : '🔍 Ara'}
        </button>
      </div>

      <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#92400e' }}>
        ⚠️ Her arama Google Places API üzerinden ücretli bir isteğe denk gelir. Aynı sonuç
        tekrar aratılırsa yeni kayıt eklenmez (otomatik tekilleştirme) ama Google isteği
        yine de faturalanır.
      </div>

      {error && <div style={{ color: '#dc2626', marginBottom: 12 }}>{error}</div>}

      {result && (
        <div>
          <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 14 }}>
            <span style={{ color: '#16a34a', fontWeight: 600 }}>✅ {result.new_count} yeni</span>
            <span style={{ color: '#6b7280' }}>♻️ {result.duplicate_count} zaten havuzda</span>
            <span style={{ color: '#d97706' }}>🏢 {result.existing_customer_count} zaten müşterimiz</span>
            {result.est_cost_usd > 0 && <span style={{ color: '#6b7280' }}>💵 ~${result.est_cost_usd.toFixed(3)}</span>}
          </div>

          <div style={{ maxHeight: 400, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
            {result.leads.map(lead => (
              <div key={lead.id} style={{ padding: '10px 14px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontWeight: 600 }}>{lead.name}</div>
                  <div style={{ fontSize: 13, color: '#6b7280' }}>{lead.address}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div>{lead.phone || '—'}</div>
                  {lead.is_existing_customer ? <span style={{ fontSize: 12, color: '#d97706' }}>Zaten müşterimiz</span> : null}
                </div>
              </div>
            ))}
            {result.leads.length === 0 && (
              <div style={{ padding: 20, textAlign: 'center', color: '#6b7280' }}>Bu aramada yeni sonuç bulunamadı.</div>
            )}
          </div>

          {nextPageToken && (
            <button
              onClick={() => runSearch(nextPageToken)}
              disabled={loading}
              style={{ marginTop: 12, padding: '8px 16px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', color: '#1e293b', cursor: 'pointer' }}
            >
              {loading ? 'Yükleniyor...' : 'Daha fazla getir'}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default DiscoveryView;
